import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
} from "@angular/core";
import { AuthenticationService } from "./services/security";
import moment from "moment";
// Parité V1 : webpack embarquait toutes les locales moment ; esbuild (Angular 21) non → moment.locale("fr") restait en anglais.
import "moment/locale/fr";
import { DisplayService } from "./services";
import { debounce } from "@shared/decorator/debounce.decorator";
import { Location } from "@angular/common";
import i18nCountries from "i18n-iso-countries";
// Parité V1 : `require("i18n-iso-countries/langs/fr.json")` remplacé par un import JSON statique
// (resolveJsonModule) — même contenu, même effet.
import frCountriesLocale from "i18n-iso-countries/langs/fr.json";
import { unblockBodyScroll } from "primeng/dom";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  standalone: false,
})
export class AppComponent implements AfterViewChecked, OnDestroy {
  title = "Décisiel - Logiciel de gouvernance";
  headerVisible = false;
  goToTopButtonVisible: boolean;
  isAnonymous: boolean = false;
  IsloginPage: boolean;
  IslikeloginPage: boolean;
  remainingTime: number;
  display: boolean = false;
  timeout: number;
  deconnect: boolean;
  interval: any;
  private overlayMaskWatchdog: MutationObserver;
  private overlayMaskSweepInterval: any;

  constructor(
    private displayService: DisplayService,
    private authService: AuthenticationService,
    private location: Location,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.displayService.emitChangeResolution(window.innerWidth);
    moment.locale("fr");
    i18nCountries.registerLocale(frCountriesLocale as any);
    this.isAnonymous = false;
    this.headerVisible = this.authService.IsAuthenticated();
    this.authService.authenticationState.subscribe(() => {
      this.headerVisible = this.authService.IsAuthenticated();
      if (this.headerVisible == null) this.headerVisible = false;
      this.isAnonymous = this.checkAnonymous();
    });
    this.IslikeloginPage = this.checkIslikelogin();
    this.authService.isLoginPage.subscribe((response) => {
      this.IsloginPage = response;
      this.isAnonymous;
      this.headerVisible;
    });

    this.authService.sessionExpired.subscribe((res: boolean) => {
      if (res == true) {
        this.deconnect = true;
        this.remainingTime = 59;
        this.timeout = this.authService.sTimeout;
        this.interval = setInterval(() => {
          this.decount();
        }, 1000);

        this.display = true;
      }
    });

    this.startOverlayMaskWatchdog();
  }

  ngOnDestroy() {
    this.overlayMaskWatchdog?.disconnect();
    clearInterval(this.overlayMaskSweepInterval);
  }

  /**
   * Filet de sécurité PrimeNG 21 (Drawer et Dialog) : reproduit et confirmé via Playwright sur
   * ClientAppV2 — leur setter `visible` ne déclenche le nettoyage du masque (backdrop) que lors
   * d'une fermeture interne (bouton de fermeture natif, clic sur le masque, Echap) ; une fermeture
   * pilotée depuis le composant consommateur via `[(visible)]="flag"; flag = false` (le mode de
   * fermeture le plus courant dans cette appli — boutons Enregistrer/Annuler) ne déclenche jamais
   * `disableModality()` : le masque reste dans le DOM en pointer-events:auto plein écran et bloque
   * tous les clics de l'application, sur toutes les pages, jusqu'au rechargement complet.
   * Deux filets complémentaires :
   * - transition de sortie amorcée mais jamais terminée (clic sur le masque, Echap) : on force la
   *   suppression une fois la transition censée être achevée ;
   * - transition jamais amorcée (fermeture via [(visible)] externe) : balayage périodique qui
   *   retire les masques orphelins (aucun p-drawer/p-dialog correspondant encore ouvert).
   * Sans impact sur le cas nominal, déjà nettoyé par PrimeNG avant que ces filets n'agissent.
   */
  private startOverlayMaskWatchdog() {
    const leaveClass = "p-overlay-mask-leave-active";
    const forceRemoveIfStuck = (mask: Element) => {
      setTimeout(() => {
        if (mask.isConnected && mask.classList.contains(leaveClass)) {
          this.removeMaskAndMaybeUnblockScroll(mask);
        }
      }, 400);
    };

    this.overlayMaskWatchdog = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === "attributes" &&
          mutation.target instanceof Element &&
          mutation.target.classList.contains("p-overlay-mask") &&
          mutation.target.classList.contains(leaveClass)
        ) {
          forceRemoveIfStuck(mutation.target);
        }
        mutation.addedNodes.forEach((node) => {
          if (
            node instanceof Element &&
            node.classList.contains("p-overlay-mask") &&
            node.classList.contains(leaveClass)
          ) {
            forceRemoveIfStuck(node);
          }
        });
      }
    });

    this.overlayMaskWatchdog.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    this.overlayMaskSweepInterval = setInterval(() => {
      const hasOpenDrawer = !!document.querySelector('.p-drawer[data-p-open="true"]');
      if (!hasOpenDrawer) {
        document.querySelectorAll(".p-drawer-mask").forEach((mask) => this.removeMaskAndMaybeUnblockScroll(mask));
      }

      const hasOpenDialog = !!document.querySelector(".p-dialog");
      if (!hasOpenDialog) {
        document.querySelectorAll(".p-dialog-mask").forEach((mask) => this.removeMaskAndMaybeUnblockScroll(mask));
      }
    }, 1000);
  }

  private removeMaskAndMaybeUnblockScroll(mask: Element) {
    mask.remove();
    if (!document.querySelector(".p-overlay-mask")) {
      unblockBodyScroll();
    }
  }

  decount() {
    this.remainingTime--;
    if (this.remainingTime == 0 && this.deconnect) {
      this.disconnect();
    }
  }

  disconnect() {
    this.deconnect = false;
    clearInterval(this.interval);
    this.authService.logout();
    this.display = false;
  }

  continue() {
    this.deconnect = false;
    clearInterval(this.interval);
    this.authService.setSessionTimeout();
    this.display = false;
  }

  elem;
  @HostListener("window:scroll", [])
  onWindowScroll() {
    this.goToTopButtonVisible = window.pageYOffset > 100;
  }

  @HostListener("window:resize", ["$event"])
  @debounce()
  onResize(event) {
    this.displayService.emitChangeResolution(window.innerWidth);
  }

  goToTopPage() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  checkAnonymous(): boolean {
    let searchPatterns = ["send-code", "verify-code", "ConfirmEmail"];
    return searchPatterns.some(
      (v: string) => this.location.path().indexOf(v) >= 0
    );
  }
  setFullscreen(event) {
    this.elem = document.documentElement;
    if (event) {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen();
      }
      `]`;
    }
  }
  ngAfterViewChecked() {
    // Parité V1 : detectChanges() forcé après chaque cycle (raison du maintien de la
    // détection de changement zone-based — ne pas retirer sans campagne de validation).
    this.cdRef.detectChanges();
  }

  checkIslikelogin(): boolean {
    let searchPatterns = [
      "ResetPassword",
      "ConfirmEmail",
      "lostPassword",
      "send-code",
      "verify-code",
    ];
    return searchPatterns.some(
      (v: string) => this.location.path().indexOf(v) >= 0
    );
  }
}
